// stripeUtils.ts

import { axiosPost } from '../../../../modules/axiosHelper'

export interface ICreatePurchaseForStripe {
  id: number
  user_id: number
  content_program_id: number
  amount: number
  amount_dollar: string
  method: string
  currency: string
  checkout: boolean
  payment_key: null
  pg_provider: null
  receipt_url: null
  created_at: Date
  updated_at: Date
  merchant_uid: string
  status: number
}

export interface IClientSecretURL {
  client_secret: string
  content_program_purchase: ContentProgramPurchase
  error?: any
}

export interface ContentProgramPurchase {
  merchant_uid: string
  payment_key: string
  id: number
  user_id: number
  content_program_id: number
  amount: number
  amount_dollar: string
  method: string
  currency: string
  checkout: boolean
  pg_provider: null
  receipt_url: null
  created_at: Date
  updated_at: Date
  status: number
}

export const createPurchaseForStripe = async (
  payload: any,
  createUrl: string,
  alertAmountText: string,
  createPurchaseStripeErrorCallback: any
) => {
  if (payload.amount < 1000) {
    alert(alertAmountText)
    window.location.reload()
    return
  }

  const response = await axiosPost(createUrl, payload)
  console.log(response, 'responseresponseresponseresponse')
  if (response?.error) {
    createPurchaseStripeErrorCallback(response?.content_program_purchase?.id, response?.error)
    return
  }
  if (response) {
    return response.content_program_purchase
  }
}

export const getClientSecret = async (
  setStripeLoading: any,
  payload: any,
  setStripeClientSecret: any,
  clientSecretUrl: (id) => string,
  alertAmountText: string,
  createPurchaseStripeErrorCallback: any,
  createUrl: string,
  setStripeAmount: any
) => {
  setStripeLoading(true)

  // Stripe를 위한 Content Program Purchase 정보 생성
  const response: ICreatePurchaseForStripe = await createPurchaseForStripe(
    payload,
    createUrl,
    alertAmountText,
    createPurchaseStripeErrorCallback
  )

  if (response) {
    // Stripe를 위한 Secret Url 생성
    const result: IClientSecretURL = await axiosPost(clientSecretUrl(response.id))
    if (result?.client_secret) {
      setStripeClientSecret(result?.client_secret)
      setStripeAmount(result?.content_program_purchase?.amount_dollar)
    } else {
      alert(result.error)
      setStripeClientSecret(null)
    }
  }
}
